// extracted by mini-css-extract-plugin
module.exports = {"container":"Searchbox_container__7iqwF"};